import { LOCAL_STORAGE_KEY } from "./LOCAL_STORAGE_KEY";

export const clearLocalState = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
};
